module.exports = __webpack_public_path__ + "img/card-img_1.2ceeebbd.png";